export default "__VITE_ASSET___q7APc74__"